export const logosData = {
  KCTLogo: {
    name: "KČT Logo",
    path: "/homepage",
    src: "/images/KCT-oblastMSK-logo.png"
  },
  mainPartnerLogo: {
    name: "Město Hlučín",
    path: "https://www.hlucin.cz/",
    src: "/images/partners-logos/Hlucin-logo.jpg"
  },
  partnersLogos: [
    { name: "Sdružení obcí Hlučínska", path: "https://www.hlucinsko.eu/", src: "/images/partners-logos/sdruzeni-obci-hlucinska-logo.png" },
    { name: "Muzeum Hlučínska", path: "https://www.muzeum-hlucinska.cz/", src: "/images/partners-logos/muzeum-hlucinska-logo.png" },
    { name: "Moravskoslezsky kraj", path: "https://www.msk.cz/", src: "/images/partners-logos/MSK-logo.png" },
    { name: "213RBP", path: "https://www.rbp213.cz/", src: "/images/partners-logos/213rbp-logo.png" },
    { name: "ANNO LIBRI", path: "https://annolibri.cz/", src: "/images/partners-logos/ANNO-LIBRI-logo.png" },
    { name: "YO sport", path: "https://www.yosport.cz/", src: "/images/partners-logos/yo-sport-logo.png" },
    { name: "Itixo", path: "https://www.itixo.com/", src: "/images/partners-logos/ITIXO-logo.png" },
    { name: "Chata Prašivá", path: "https://www.chataprasiva.cz/", src: "/images/partners-logos/Prasiva-logo.png" },
    { name: "Kudy z nudy", path: "https://www.kudyznudy.cz/", src: "/images/partners-logos/kudy-z-nudy-logo.png" },
    { name: "IVV (Internationaler Volkssportverband)", path: "https://kct.cz/o-klubu/sekce/sekce-ivv-iml/", src: "/images/partners-logos/IVV-logo.png" },
    { name: "Sport a kultura Hlučín", path: "https://www.sak-hlucin.cz/cs/", src: "/images/partners-logos/sak-hlucin.png" },
    { name: "MAXNER autodoprava", path: "https://www.maxner.cz", src: "/images/partners-logos/Maxnerbus-logo.png" },
    { name: "Vivobarefoot", path: "https://www.vivobarefoot.cz", src: "/images/partners-logos/Vivobarefoot-logo.png" },
    { name: "Diecéze ostravsko-opavská", path: "https://www.doo.cz", src: "/images/partners-logos/Dieceze-ostravsko-opavska-logo.png" },
  ]
}